import styled from "@emotion/styled";
import { flexBetween } from "../config/commonCSS";

export const FlexBetweenContainer = styled.div<{
  direction?: "row" | "column";
}>`
  ${flexBetween};
  flex-direction: ${props => props.direction};
`;
